/**
 * Storage alert thresholds shared by the server and the interface: 80 % warns, 90 % asks for
 * action, 100 % means new messages are refused. The same sequence applies to a mailbox against its
 * cap and to an organisation against its pooled storage.
 */
export type StorageLevel = 0 | 80 | 90 | 100;
export function storageLevel(used: number, limit: number | null | undefined): StorageLevel {
  if (!limit || limit <= 0) return 0;
  const ratio = used / limit;
  return ratio >= 1 ? 100 : ratio >= 0.9 ? 90 : ratio >= 0.8 ? 80 : 0;
}
